export default "__VITE_ASSET__f01e1b34__"